import { toast } from "@loot-os/ui/components/sonner";

/**
 * The most order windows one press opens. Retool had no cap; each window is a whole dashboard
 * loading its order, so a select-all on a long list would lock the browser up.
 */
export const OPEN_IN_TABS_MAX = 50;

/** The button's words on both pages, Retool's own: the reminder that pop-ups must be allowed. */
export const OPEN_IN_TABS_LABEL = "Open in Tabs (Allow Pop Ups)";

/**
 * Retool's "Open in Tabs" (TCG Order List and Packing): one window per order, each on its order
 * page. Browsers block a burst of `window.open` unless the user allows pop-ups, so a blocked
 * window is counted and the toast says how to allow them. Each window is named for its order, so
 * pressing again reuses it.
 */
export function openOrdersInTabs(orderIds: readonly string[]): void {
  if (orderIds.length > OPEN_IN_TABS_MAX) {
    toast.error(`Select at most ${OPEN_IN_TABS_MAX} orders to open in tabs.`);
    return;
  }
  const blocked = orderIds.filter(
    (orderId) => !window.open(`/fulfillment/orders/${orderId}`, `order-${orderId}`),
  ).length;
  if (blocked > 0) {
    toast.error(
      `The browser blocked ${blocked} of ${orderIds.length} tabs. Allow pop-ups for this site and press Open in Tabs again.`,
    );
  }
}
